"use client";
import { useState } from "react";
import { AgentCardSkeleton } from "../agents/allAgents";
import { useGetDevelopers } from "@/hooks/main-hook";
import Paginate from "../paginate/paginate";
import Link from "next/link";
import Image from "next/image";
import { socialMediaPlatforms } from "@/data/main-data";

export default function Developers() {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isLoading } = useGetDevelopers({ page: currentPage });

  const totalPages = data?.pagination?.totalPages || 0;

  return (
    <div className="mt-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
        {isLoading ? (
          <>
            {[...Array(8)].map((_, index) => (
              <AgentCardSkeleton key={index} />
            ))}
          </>
        ) : (
          data?.developers?.map((dev: any) => (
            <div key={dev.id} className="bg-white shadow px-4 py-2">
              <Link
                href={`/developers/${dev?.slug}`}
                className="flex justify-center"
              >
                <Image
                  src={dev?.user?.photo || "/user.webp"}
                  alt={dev?.user?.username}
                  width={500}
                  height={500}
                  priority
                  className="rounded-b-full"
                />
              </Link>
              <h3 className="text-lg font-semibold mt-3 text-center text-dark capitalize">
                {dev?.user?.username}
              </h3>

              <ul className="flex items-center justify-center gap-4 py-4">
                {dev?.social_links?.map((social: any, index: number) => {
                  const socialIcons = socialMediaPlatforms.find(
                    (e) => e.value === social.platform
                  );

                  return (
                    <li
                      key={index}
                      className="border  rounded-full border-main hover:bg-main hover:text-white duration-500"
                    >
                      <Link
                        href={social.url}
                        target="_blank"
                        rel="noreferrer"
                        className="p-2 block"
                      >
                        {socialIcons && <socialIcons.icon size={20} />}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))
        )}
      </div>

      {totalPages > 1 && (
        <Paginate
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
      )}
    </div>
  );
}
